function HouseIcon({ size = 20 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
    >
      <g fill="none" stroke="#454546" strokeWidth="1">
        <circle cx="6" cy="6" r="6" stroke="none" />
        <circle cx="6" cy="6" r="5.5" fill="none" />
      </g>
      <path
        d="M1254.491,349.8c-.3-.295-.605-.594-.911-.889a.189.189,0,0,1-.063-.151v-1.092a.382.382,0,0,0-.241-.379.388.388,0,0,0-.426.066.4.4,0,0,0-.135.317v.384l-.065-.06-.691-.677a.994.994,0,0,0-.083-.078,1.069,1.069,0,0,0-1.444.078l-2.581,2.529a.835.835,0,0,0-.077.085l-.012.017a.386.386,0,0,0,.134.552.408.408,0,0,0,.514-.09l.022-.022a.271.271,0,0,0,0,.037v1.754q0,.034,0,.069a.79.79,0,0,0,.827.746h1.142c.026,0,.052,0,.085,0v-1.919h1.426V353a.324.324,0,0,0,.061,0h1.195a.826.826,0,0,0,.148-.012.78.78,0,0,0,.648-.764v-1.79a.308.308,0,0,0,0-.038l.008.008a.744.744,0,0,0,.08.072.4.4,0,0,0,.424.042.435.435,0,0,0,.224-.281l0-.13A.652.652,0,0,0,1254.491,349.8Z"
        transform="translate(-1245.196 -344)"
        fill="#454546"
      />
    </svg>
  );
}

export default HouseIcon;
